import { AmplitudeEvent } from "./AmplitudeEvent";

const KEY_SETTING_MAP = {
	showAllDayEvents: "All day events",
	showHiddenMeetings: "Show hidden events",
	showEventsWithOnlyMe: "Only me events",
};

export class MeetingVisibilityToggledEvent extends AmplitudeEvent {
	constructor( key, value ) {
		super();
		this.name = "Meeting Visibility Setting Toggled";
		this.eventProperties.setting = KEY_SETTING_MAP[ key ];
		this.eventProperties.setting_value = value ? "Enabled" : "Disabled";
	}
}



// WEBPACK FOOTER //
// ./src/telemetry/MeetingVisibilityToggledEvent.js